import { compose, concat, join, map } from 'ramda';
import { CRLF } from '../../../constants/newlines';

const newLine = CRLF;
const newLineTab = newLine + '\t';

// ParameterDefinition -> String
const formatParameter = ({ name, description }) =>
    `${name}=${description || name}`;

// [ParameterDefinition] -> [String]
const formatParameters = map(formatParameter);

// String -> String
const markupOptionalParameter = (p) => `[${p}]`;

// ([ParameterDefinition], [ParameterDefinition]) -> String
const formatAllParameters = compose(
    join(''),
    map(concat(newLineTab)),
    (req, opt) => [
        ...formatParameters(req),
        ...formatParameters(opt).map(markupOptionalParameter),
    ],
);

// ([ParameterDefinition], [ParameterDefinition], String) -> String
export const getUsageTextForCommand = (
    optionalParameters,
    requiredParameters,
    commandName,
) =>
    [
        'Usage is: ',
        newLine,
        newLine,
        commandName,
        formatAllParameters(requiredParameters, optionalParameters),
    ].join('');
